/* src/app/modules/supportTickets/tickets.component.css */
:host {
  --cf-brand: #1e2235;
  --cf-brand-dark: #1e2235;
}
:host ::ng-deep .table-title__icon {
  background: #eef0f5;
}
:host ::ng-deep .app-button.primary {
  color: #ffffff !important;
}
.sp-card {
  padding: 0;
  overflow: hidden;
}
.sp-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--cf-border);
}
.sp-tabs {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background: var(--cf-bg);
}
.sp-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--cf-text-muted);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.sp-tab:hover {
  color: var(--cf-text);
}
.sp-tab--active {
  background: var(--cf-surface);
  color: var(--cf-text);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.sp-tab__count {
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 999px;
  background: var(--cf-border);
  color: var(--cf-text);
  font-size: 11px;
  text-align: center;
}
.sp-tab--active .sp-tab__count {
  background: #1e2235;
  color: #ffffff;
}
.sp-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 260px;
  max-width: 360px;
  padding: 8px 12px;
  border: 1px solid var(--cf-border);
  border-radius: 10px;
  background: var(--cf-surface);
}
.sp-search:focus-within {
  border-color: #1e2235;
}
.sp-search mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--cf-text-muted);
}
.sp-search input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 13px;
  color: var(--cf-text);
}
.sp-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.sp-row {
  position: relative;
  display: grid;
  grid-template-columns: 4px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 16px;
  padding: 14px 16px 14px 0;
  border-bottom: 1px solid var(--cf-border);
  cursor: pointer;
  transition: background 0.12s ease;
}
.sp-row:last-child {
  border-bottom: 0;
}
.sp-row:hover {
  background: #fafbfc;
}
.sp-priority {
  align-self: stretch;
  width: 4px;
  border-radius: 0 4px 4px 0;
}
.sp-priority--low {
  background: #94a3b8;
}
.sp-priority--medium {
  background: #f59e0b;
}
.sp-priority--high {
  background: #dc2626;
}
.sp-row__main {
  min-width: 0;
}
.sp-row__subject {
  font-size: 14px;
  font-weight: 700;
  color: var(--cf-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sp-row__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  margin-top: 4px;
  font-size: 12px;
  color: var(--cf-text-muted);
}
.sp-tag {
  padding: 1px 8px;
  border-radius: 6px;
  background: var(--cf-bg);
  border: 1px solid var(--cf-border);
  color: var(--cf-text);
  font-weight: 600;
}
.sp-row__user {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.sp-row__user mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.sp-row__side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
.sp-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.12);
  color: #b45309;
  font-size: 12px;
  font-weight: 700;
}
.sp-status mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.sp-status--resolved {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}
.sp-row__date {
  font-size: 12px;
  color: var(--cf-text-muted);
  white-space: nowrap;
}
.sp-row__actions {
  display: flex;
  gap: 8px;
}
.sp-btn {
  border-radius: 8px !important;
  font-size: 13px !important;
}
.sp-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  margin-right: 2px;
}
.sp-btn--resolve {
  color: #15803d !important;
  border-color: rgba(22, 163, 74, 0.4) !important;
}
.sp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 48px 16px;
  text-align: center;
  color: var(--cf-text-muted);
}
.sp-empty mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #cbd5e1;
}
.sp-empty p {
  margin: 0;
  font-size: 14px;
}
@media (max-width: 768px) {
  .sp-row {
    grid-template-columns: 4px minmax(0, 1fr) auto;
  }
  .sp-row__actions {
    grid-column: 2 / -1;
  }
  .sp-search {
    max-width: none;
  }
}
/*# sourceMappingURL=tickets.component.css.map */
